var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.058,
    height: 91.068,
    viewBox: "0 0 78.058 91.068",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-invoice-4602213",
    transform: "translate(-140 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M140,50.18A15.178,15.178,0,0,1,155.178,35h52.039v4.336H155.178A10.842,10.842,0,0,0,144.336,50.18v71.554h52.039V54.516h4.337V123.9a2.169,2.169,0,0,1-2.169,2.169H142.169A2.168,2.168,0,0,1,140,123.9Z",
    transform: "translate(0 -0.002)",
    fill: "#021869",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M233.33,361.67h26.02v4.336H233.33Z",
    transform: "translate(-75.984 -265.957)",
    fill: "#021869",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M233.33,431.67h26.02v4.336H233.33Z",
    transform: "translate(-75.984 -322.947)",
    fill: "#021869",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M443.33,45.841a10.842,10.842,0,0,1,21.683,0V67.525a2.169,2.169,0,0,1-2.169,2.169H445.5a2.169,2.169,0,0,1-2.169-2.169Zm10.842-6.5a6.5,6.5,0,0,0-6.5,6.5V65.356h13.01V45.841A6.505,6.505,0,0,0,454.172,39.336Z",
    transform: "translate(-246.955)",
    fill: "#021869",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M245,147.587A7.589,7.589,0,0,1,252.589,140h11.926v4.336H252.589a3.252,3.252,0,1,0,0,6.5h6.5a7.589,7.589,0,1,1,0,15.178H247.169v-4.336h11.925a3.252,3.252,0,1,0,0-6.5h-6.5A7.589,7.589,0,0,1,245,147.587Z",
    transform: "translate(-85.485 -85.484)",
    fill: "#021869",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M296,116.67v6.5h-4.336v-6.5Z",
    transform: "translate(-123.48 -66.491)",
    fill: "#021869",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M296,268.33v6.5h-4.336v-6.5Z",
    transform: "translate(-123.48 -189.965)",
    fill: "#021869",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };